import { IBreadCrumb } from '@/@types/health/healthBreadcrumb'

export const SCREEN_PROJECT = 1
export const SCREEN_PROFILE_MAIN = 2
export const SCREEN_PROFILE_CO = 3
export const SCREEN_LOAN = 4
// L'ordre numérique des écrans est significatif : StepsBreadcrumb compare currentStep >= breadcrumb.step
export const SCREEN_INSURANCE = 5
export const SCREEN_CONTACT = 6

export const VISIBLE_STEPS_COUNT = 5

// Écrans balayés à la soumission pour retrouver le premier en erreur : le projet est déjà validé, les coordonnées pas encore atteintes
export const QUOTATION_ERROR_SCREENS_ORDER = [SCREEN_PROFILE_MAIN, SCREEN_PROFILE_CO, SCREEN_LOAN, SCREEN_INSURANCE]

const SCREEN_TO_VISIBLE_STEP: Record<number, number> = {
    [SCREEN_PROJECT]: 1,
    [SCREEN_PROFILE_MAIN]: 2,
    [SCREEN_PROFILE_CO]: 2,
    [SCREEN_LOAN]: 3,
    [SCREEN_INSURANCE]: 4,
    [SCREEN_CONTACT]: 5,
}

const VISIBLE_STEP_TO_SCREEN: Record<number, number> = {
    1: SCREEN_PROJECT,
    2: SCREEN_PROFILE_MAIN,
    3: SCREEN_LOAN,
    4: SCREEN_INSURANCE,
    5: SCREEN_CONTACT,
}

export const screenToVisibleStep = (screen: number): number => SCREEN_TO_VISIBLE_STEP[screen] ?? 1

export const visibleStepToScreen = (visibleStep: number): number => VISIBLE_STEP_TO_SCREEN[visibleStep] ?? SCREEN_PROJECT

export const buildLoanQuotationBreadcrumbs = (screen: number): IBreadCrumb[] => [
    { step: SCREEN_PROJECT, visible_step: 1, label: 'Type de projet' },
    {
        step: SCREEN_PROFILE_MAIN,
        visible_step: 2,
        label: screen === SCREEN_PROFILE_CO ? 'Profil co-emprunteur' : 'Profil emprunteur',
    },
    { step: SCREEN_LOAN, visible_step: 3, label: 'Caractéristiques de votre emprunt' },
    { step: SCREEN_INSURANCE, visible_step: 4, label: 'Votre assurance' },
    { step: SCREEN_CONTACT, visible_step: 5, label: 'Vos coordonnées' },
]

// L'étape coordonnées n'existe qu'après soumission du devis, seul moment où les prêts sont persistés côté serveur
export const isContactStepReachable = (quote: { loans?: unknown[] | null } | null | undefined): boolean =>
    !!quote?.loans?.length
